import { createTheme } from "@mui/material/styles";
import { theme } from "@sodexo/ui-components";

export const aipTheme = createTheme(
  {
    variables: {
      topBarHeight: 54,
      docUpdatingBannerHeight: 24,
      leftNaveWidth: 64,
    },
  },
  theme,
);

declare module "@mui/material/styles" {
  // fix the type error when referencing the Theme object in your styled component
  interface Theme {
    variables: {
      topBarHeight: number;
      docUpdatingBannerHeight: number;
      leftNaveWidth: number;
    };
  }
  // fix the type error when calling `createTheme()` with a custom theme option
  interface ThemeOptions {
    variables: {
      topBarHeight: number;
      docUpdatingBannerHeight: number;
      leftNaveWidth: number;
    };
  }
}

export function cssLimitTextToLines(lines: number) {
  return `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
  `;
}
